import moment from '@/moment-gp'

export const TYPE_MAP = {
  'TASKLIST':            "flow-tasklist", // Regular Commitment (Tasklist-Commitment or Time-Commtiment)
  'TIME_BASED_TASKLIST': "flow-tasklist", //
  'SEQUENCE':            "flow-sequence", // Sequence Commiment
  'FIXED_TIME':          "flow-fixed-time-event", // Fixed time event (e.g. Meeting, Phone call, TV Show)
  'INLINE_TASK':         "flow-quick-session",  // A task that was manually created "inline"
  'ADHOC_SESSION':       "flow-quick-session",  // A task that was manually created "inline"
  'TEMPLATE':            "flow-dummy",      //
  'NOT_PLANNED':         "flow-placeholder",// Nothing planned
  'PAUSE':               "flow-dummy",      //
  'CHECKLIST':           "flow-dummy",      //
  'AMOUNT':              "flow-dummy",      //
  'HABIT':               "flow-dummy",      //
  'START_DAY':           "flow-day-marker",
  'END_DAY':             "flow-day-marker",
  'CURRENT_TIME':        "flow-current-time",
  'TIMESLOT_BREAKER':    "flow-day-marker",
  'EXTERNAL_EVENT':      "flow-external",
}

// ----------------------------------------------------------------------------
export function make_block( type, from, to, title, config = {} ) {

  const VALID_BLOCK_TYPES = Object.keys(TYPE_MAP);

  if ( !VALID_BLOCK_TYPES.includes( type ) ) {
    throw new Error('Invalid block type: ' + type)
  }

  let no_drag = [ 'START_DAY', 'END_DAY', 'CURRENT_TIME', 'NOT_PLANNED' ].includes( type );

  return {
    type,
    fixedFrom: from,
    fixedTo: to,
    fixedDuration: to - from,
    suggestedFrom: null,
    suggestedDuration: null,
    // from: null, // added later
    // to: null, // added later
    title,
    no_drag,
    config,
    component: TYPE_MAP[ type ]
  }
}

// ----------------------------------------------------------------------------
export function time( str ) {
  console.log('time()', str, moment(str, 'YYMMDDHH:mm').unix())
  return moment(str, 'YYMMDDHH:mm').unix()
}

// ----------------------------------------------------------------------------
export function make_dummy_plan(dateString) {
  let dayplan = []

  /*let C1_config = {
    "goalId": "eBgE9ovNQaiUiq7Y0Xdreg",
    "commitmentId": "Xm8zE9PlS9KmhiPWWu1T_g",
  }*/

  dayplan.push( make_block( 'START_DAY',  time(dateString + '07:00'),  null,          'Start of day' ) );
  //dayplan.push( make_block( 'COMMITMENT', time('8:00'),  time('9:00'),  'C1', C1_config ) );
  //dayplan.push( make_block( 'FIXED_TIME', time('9:00'),  time('10:30'), 'FT1' ) );
  //dayplan.push( make_block( 'COMMITMENT', time('10:45'), time('12:00'), 'C2', C1_config ) );
  // dayplan.push( make_block( 'FIXED_TIME', time('15:00'), time('16:00'), 'FT2' ) );
  // dayplan.push( make_block( 'COMMITMENT', time('18:00'), time('21:10'), 'C3', C1_config ) );
  dayplan.push( make_block( 'END_DAY',    time(dateString + '23:00'), null,          'End of day' ) ); // fixedEnd instead?

  return dayplan;
}
